<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Services
	import { postReq } from '../../../services/http';
	import { CURRENCIES } from '../../../constants';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { capFirstChar } from '../../../helpers/utilities';
	//Stores
	import { user_settings } from 'src/stores/account/user';
	// Design system components
	import { Row, Col, Button, Select, Alert } from '@Shelly/shelly-design-system';

	let currency = {
		title: $user_settings.currency || '',
		value: $user_settings.currency || '',
	};

	const options = CURRENCIES.map((e) => {
		return {
			title: e.CurrencyCode,
			value: e.CurrencyCode,
		};
	});

	$: errorOnLoad =
		currency?.value && !options.some((e) => e.value === currency?.value.toUpperCase())
			? // If there is no currency in options that match the current currency value
				// And because currency.value might be an ''- when comparing an '' with currency options nothing is found

				//checks if there is actually value present
				$format('alert_error_currency', {
					default: 'Invalid currency.',
				})
			: undefined;

	const setCurrency = async () => {
		const res = await postReq(
			'/v2/users/power-prices/currency',
			{ currency: currency.value },
			undefined,
			undefined,
			undefined,
			true,
		);
		const successCheck = res?.hasOwnProperty('isok') ? res?.isok : !res?.error;
		if (successCheck) {
			user_settings.set({ ...$user_settings, currency: currency.value });
		}
		onSettingsResponse(res, null, {
			success: $format('currency_set', {
				default: 'Currency set successfully.',
			}),
		});
	};

	// enable the option to set currency to an empty string might revert later
	// options.push({
	// 	title: 'None',
	// 	value: ''
	// });
</script>

{#if errorOnLoad}
	<Alert
		class="mb-s"
		heading={capFirstChar(
			$format('currency_re_add', {
				default:
					'Your current currency is not supported. Please select a currency from the listed options.',
			}),
		)}
	/>
{/if}
<Row>
	<Col xs="12" md="3">
		<Select
			isAutocomplete
			size="m"
			label={$format('label_currency', { default: 'Currency' })}
			icon="fas fa-money-bill-wave"
			{options}
			bind:value={currency}
			error={errorOnLoad}
			id="select-9u9tqib"
			aria-labelledby="select-9u9tqib"
		/>
	</Col>
	<Col xs="12" md="3">
		<Button
			size="m"
			class="text-capitalize width-md-auto width-sm-full"
			disabled={currency?.value == ''}
			on:click={setCurrency}>{$format('button_save', { default: 'save' })}</Button
		>
	</Col>
</Row>
